import React from 'react';

import { Bold } from '@styles/generalStyles';

export const b = (chunks: React.ReactNode[]) => <Bold key={chunks?.toString()}>{chunks}</Bold>;
